import { Model } from "vuex-fetch-factory";

export interface ContactRaw {
  id: number;
  organisation_id: number;
  first_name: string;
  last_name: string;
  gender: string;
  phone_number: string;
  mobile_phone_number: string;
  main_contact: boolean;
  email_address: string;
  access: boolean;
}

export class ContactModel implements Model<ContactModel, ContactRaw> {
  public id: number = 0;
  public organisation_id: number = 0;
  public first_name: string = "";
  public last_name: string = "";
  public gender: string = "";
  public phone_number: string = "";
  public mobile_phone_number: string = "";
  public main_contact: boolean = false;
  public email_address: string = "";
  public access: boolean = false;

  public getNew(): ContactModel {
    return new ContactModel();
  }

  public fillModel(raw: ContactRaw): this {
    this.id = raw.id;
    this.organisation_id = raw.organisation_id;
    this.first_name = raw.first_name;
    this.last_name = raw.last_name;
    this.gender = raw.gender;
    this.phone_number = raw.phone_number;
    this.mobile_phone_number = raw.mobile_phone_number;
    this.main_contact = raw.main_contact;
    this.email_address = raw.email_address;
    this.access = raw.access;
    return this;
  }

  public getRaw(): ContactRaw {
    return {
      id: this.id,
      organisation_id: this.organisation_id,
      first_name: this.first_name,
      last_name: this.last_name,
      gender: this.gender,
      phone_number: this.phone_number,
      mobile_phone_number: this.mobile_phone_number,
      main_contact: this.main_contact,
      email_address: this.email_address,
      access: this.access
    };
  }

  public get full_name(): string {
    return `${this.first_name} ${this.last_name}`;
  }
}
